// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__22NnZ","author":"Table_author__1fK73","authorImage":"Table_authorImage__2H_MM","unreadRow":"Table_unreadRow__3x50v"};